import { createContext, useState, SetStateAction, Dispatch, PropsWithChildren } from 'react';
import { Instance } from 'tippy.js';

type ClickOutsideHandler = ((instance: Instance, event: Event) => void) | undefined;

const noop = () => {};

const tooltipContext = {
   openDataPointId: null as string | null,
   setOpenDataPointId: noop as Dispatch<SetStateAction<string | null>>,
   onClickOutsideTooltip: noop as ClickOutsideHandler,
   setOnClickOutsideTooltip: noop as Dispatch<SetStateAction<ClickOutsideHandler>>,
};

const TooltipContext = createContext(tooltipContext);

function getDefaultOutsideClickHandler(
   setOpenDataPointId: Dispatch<SetStateAction<string | null>>
) {
   return (_comp: Instance, event: Event) => {
      if (!(event.target instanceof Element)) {
         return;
      }
      setOpenDataPointId(null);
   };
}

function OpenTooltipProvider({
   initialOpenDataPointId,
   children,
}: PropsWithChildren<{ initialOpenDataPointId?: string }>) {
   const [openDataPointId, setOpenDataPointId] = useState(initialOpenDataPointId || null);

   const [onClickOutsideTooltip, setOnClickOutsideTooltip] = useState<ClickOutsideHandler>(() =>
      getDefaultOutsideClickHandler(setOpenDataPointId)
   );

   const tooltipContext = {
      openDataPointId,
      setOpenDataPointId,
      onClickOutsideTooltip,
      setOnClickOutsideTooltip,
   };

   return <TooltipContext.Provider value={tooltipContext}>{children}</TooltipContext.Provider>;
}

export { OpenTooltipProvider, TooltipContext };
